/*
 *
 * Pages
 *
 */

import React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { delayedDispatch, setBreadcrumb, setLoader, setTitle } from "store/actions";
import { Helmet } from "react-helmet";
import { API, Endpoints } from "utils/api";
import { formatPrice } from "utils/utils";

import Strings from "utils/strings";
import { Props } from "./types";
import "./styles.scss";
import { Select, notification, Table } from "antd";
import { DateTime } from "luxon";
import xlsx from "json-as-xlsx";
import { getColumnFilter } from "utils/comp-utils";
import { ContentWrapper, Icon } from "components";
import { count } from "console";
import moment from "moment";

export class Orders extends React.Component<Props, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			orders: [],
			page: 0,
			pageSize: 100,
			total: 0,
			columnSearch: null,
			globalSearch: "",
			creationDateStart: null,
			creationDateEnd: null
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;

		dispatch(setTitle(""));

		this.getData();
		this.breadcrumb();
	}

	breadcrumb() {
		delayedDispatch(
			setBreadcrumb(() => {
				const { startDate, endDate, partnerOptions } = this.state;

				return {
					actions: [
						{
							type: "datePicker",
							text: Strings.dashboard.period,
							dates: [startDate, endDate],
							monthly: true,
							onChange: this.handleSelect,
							className: "fixedPicker"
						}
					]
				};
			})
		);
	}

	handleSelect = (dates: any) => {
		const newDates = [];
		if (dates && dates[0]) {
			const start = moment(dates[0]);
			newDates.push(start.startOf("month"));
		}

		if (dates && dates[1]) {
			const end = moment(dates[1]);
			newDates.push(end.endOf("month"));
		}

		if (newDates[0] && newDates[1] && newDates[0].isSame(newDates[1], "month")) {
			newDates[0] = moment(newDates[0]).startOf("month");
			newDates[1] = moment(newDates[1]).endOf("month");
		}

		this.setState(
			{
				creationDateStart: newDates[0],
				creationDateEnd: newDates[1]
			},
			() => this.getData()
		);
	};

	async getData(pause?: boolean) {
		const { page, pageSize, columnSearch, globalSearch, creationDateStart, creationDateEnd } = this.state;
		const { dispatch, countries } = this.props;

		setTimeout(
			async () => {
				if (columnSearch !== this.state.columnSearch || globalSearch !== this.state.globalSearch) return;
				dispatch(setLoader(true));

				const body = {
					page: page,
					perPage: pageSize,
					search: globalSearch,
					creationDateStart: creationDateStart,
					creationDateEnd: creationDateEnd
				};

				try {
					const response = await API.post({
						url: Endpoints.uriOrders("search"),
						data: body
					});

					if (response.ok) {
						const { orders = [], total = 0 } = response.data.results;

						const ordersParsed = orders.map((order: any) => {
							const countryCallingCode = order.user.phone?.substring(0, 4).replace("+", "");
							let countryOrigin;

							if (countryCallingCode) {
								const countryObj = countries.find((elem: any) => elem.callingCodes.includes(countryCallingCode));
								countryOrigin = {
									name: countryObj?.name,
									alpha2Code: countryObj?.alpha2Code
								};
							}

							return {
								...order,
								user: { ...order.user, country: countryOrigin }
							};
						});

						this.setState({ orders: ordersParsed, total });
					} else {
						notification.error({
							message: Strings.sidebar.orders,
							description: response?.data?.message || Strings.serverErrors.wentWrong,
							placement: "bottomRight",
							duration: 5
						});
					}
				} catch (err) {
					notification.error({
						message: Strings.serverErrors.title,
						description: err as string,
						placement: "bottomRight",
						duration: 5
					});
				}

				dispatch(setLoader(false));
			},
			pause ? 1000 : 0
		);
	}

	// TODO: This is the pagination and filtration for the old table
	// 		 Still need to adapt it to the new antd table component

	// get pagination() {
	// 	return {
	// 		total: this.state.total,
	// 		pageIndex: this.state.page,
	// 		pageSize: this.state.pageSize,
	// 		setPage: (page: number, size: number) => {
	// 			this.setState({ page, pageSize: size }, () => this.getData());
	// 		}
	// 	};
	// }

	// get filtration() {
	// 	const { globalSearch, columnSearch } = this.state;
	// 	return {
	// 		showGlobalSearch: true,
	// 		showColumnSearch: true,
	// 		defaultValues: { globalSearch, columnSearch },
	// 		onGlobalSearch: (globalSearch: string) => {
	// 			this.setState({ globalSearch, page: 0 }, () => this.getData());
	// 		},
	// 		onColumnSearch: (columnSearch: string) => {
	// 			this.setState({ columnSearch, page: 0 }, () => this.getData());
	// 		}
	// 	};
	// }

	getPaymentStatus(status: string) {
		const statusString = status as keyof typeof Strings.orders.paymentStatuses;
		return Strings.orders.paymentStatuses[statusString] || "-";
	}

	getShippingStatus(status: string) {
		const statusString = status as keyof typeof Strings.orders.shippingStatuses;
		return Strings.orders.shippingStatuses[statusString] || "-";
	}

	getOrderStatus = (closed: boolean) => {
		if (closed) {
			return (
				<div className="TableTag --tag-success">
					<span>{Strings.orders.closed}</span>
				</div>
			);
		}

		return (
			<div className="TableTag --tag-warning">
				<span>{Strings.orders.pending}</span>
			</div>
		);
	};

	paymentStatusRender = (status: string) => {
		if (["paid"].includes(status)) {
			return (
				<div className="TableTag --tag-success">
					<span>{this.getPaymentStatus(status)}</span>
				</div>
			);
		}

		if (["waiting_payment", "failed_payment", "pending_payment", "cancelled", "partially_refunded", "refunded"].includes(status)) {
			return (
				<div className="TableTag --tag-warning">
					<span>{this.getPaymentStatus(status)}</span>
				</div>
			);
		}
	};

	shippingStatusRender = (status: string) => {
		if (["delivered"].includes(status)) {
			return (
				<div className="TableTag --tag-success">
					<span>{this.getShippingStatus(status)}</span>
				</div>
			);
		}

		if (
			["pending_processing", "processing", "shipped", "partially_shipped", "awaiting_pickup", "partially_pickedup"].includes(status)
		) {
			return (
				<div className="TableTag --tag-warning">
					<span>{this.getShippingStatus(status)}</span>
				</div>
			);
		}
		if (["returned", "partially_returned", "cancelled", "closed"].includes(status)) {
			return (
				<div className="TableTag --tag-error">
					<span>{this.getShippingStatus(status)}</span>
				</div>
			);
		}
	};

	getPaymentType = (type: string) => {
		switch (type) {
			case "mbw":
				return "MB Way";
			case "cc":
				return Strings.orders.creditCard;
			case "bank_transfer":
				return Strings.orders.bankTransfer;
			case "cash_on_delivery":
				return Strings.orders.cashOnDelivery;
			case "cash":
				return Strings.orders.cash;
			default:
				return "-";
		}
	};

	exportOrdertsToExcel = async () => {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.post({
				url: Endpoints.uriOrders("search"),
				data: {
					limited: false
				}
			});

			if (response.ok) {
				const { orders = [] } = response.data.results;

				const content = orders.map((s: any) => ({
					date: s._created ? DateTime.fromISO(s._created).toFormat("dd/MM/yyyy") : "-",
					orderNumber: s.orderNumber !== null ? s.orderNumber : "-",
					email: s.user?.email || "-",
					name: s.user?.name || "-",
					paymentStatus: this.getPaymentStatus(s.paymentStatus),
					shippingStatus: this.getShippingStatus(s.shippingStatus),
					status: this.getOrderStatus(s.isClosed),
					total: s.total != null ? formatPrice(s.total) : "-"
				}));

				const data = [
					{
						sheet: "Orders",
						columns: [
							{ label: "Date", value: "date" },
							{ label: "Order Number", value: "orderNumber" },
							{ label: "Email", value: "email" },
							{ label: "Name", value: "name" },
							{ label: "Payment Status", value: "paymentStatus" },
							{ label: "Shipping Status", value: "shippingStatus" },
							{ label: "Status", value: "status" },
							{ label: "Total", value: "total" }
						],
						content: content
					}
				];

				const settings = {
					sheetName: "Orders",
					extraLength: 3,
					writeMode: "writeFile",
					writeOptions: {}
				};

				xlsx(data, settings);
			}
		} catch (error) {
		} finally {
			dispatch(setLoader(false));
		}
	};

	render() {
		const { orders = [] } = this.state;
		const { dispatch, partners } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.orders}</title>
					<meta name="description" content="Description of Orders" />
				</Helmet>
				<ContentWrapper>
					<div className="ScreenHeader --multi">
						<div className="ScreenHeaderLeft">
							<Icon name="box" />
							<h2>{Strings.sidebar.orders}</h2>
						</div>
						<div className="ScreenHeaderRight">
							<button className="EthicAddButton" onClick={this.exportOrdertsToExcel}>
								<Icon name="print" />
							</button>
							<button
								className="EthicAddButton"
								onClick={() => dispatch(partners ? push("/partner-orders/new") : push("/orders/new"))}
							>
								<Icon name="plus" />
							</button>
						</div>
					</div>
					<Table
						style={{ marginTop: 20 }}
						scroll={{ x: "max-content" }}
						onChange={(a, b, c) => {
							console.log(a);
							console.log(b);
							console.log(c);
						}}
						columns={[
							{
								title: Strings.fields.date,
								dataIndex: "_created",
								key: "_created",
								render: (date: string) => (date ? DateTime.fromISO(date).toFormat("dd/MM/yyyy") : "-"),
								sorter: (a: any, b: any) =>
									DateTime.fromISO(a._created).toMillis() - DateTime.fromISO(b._created).toMillis(),
								width: 120
							},
							{
								title: Strings.orders.orderNumber,
								dataIndex: "orderNumber",
								key: "orderNumber",
								render: (orderNumber: string, record: any) => {
									if (!orderNumber) return "-";

									return (
										<a
											href={`/orders/${record._id}`}
											onClick={(e) => {
												e.preventDefault();

												dispatch(push(partners ? `/partner-orders/${record._id}` : `/orders/${record._id}`));
											}}
										>
											#{orderNumber}
										</a>
									);
								},
								sorter: (a: any, b: any) => (a?.orderNumber || "").localeCompare(b?.orderNumber || ""),
								width: 150,
								...getColumnFilter("orderNumber")
							},
							{
								title: Strings.fields.country,
								dataIndex: "user",
								key: "userCountry",
								sorter: (a: any, b: any) => {
									return a?.user.country?.name.localeCompare(b?.user.country?.name);
								},
								render: (user: any) => {
									return (
										<span className="TableRowAligned">
											<div className="react-tel-input">
												<div className="selected-flag">
													<span className={`flag ${user?.country?.alpha2Code?.toLowerCase()}`} />
												</div>
											</div>
											{user?.country?.name || "-"}
										</span>
									);
								},
								...getColumnFilter(["user.country.name", "user.country.alpha2Code"])
							},
							{
								title: Strings.fields.name,
								dataIndex: "name",
								key: "name",
								render: (_, record: any) => record?.user.name || "-",
								...getColumnFilter("user.name")
							},
							{
								title: Strings.fields.email,
								dataIndex: "email",
								key: "email",
								render: (_, record: any) => record?.user.email || "-",
								...getColumnFilter("user.email")
							},
							{
								title: Strings.orders.paymentStatus,
								dataIndex: "paymentStatus",
								key: "paymentStatus",
								render: (status: string) => this.paymentStatusRender(status),
								filters: [
									{ text: Strings.orders.paymentStatuses.paid, value: "paid" },
									{ text: Strings.orders.paymentStatuses.pending_payment, value: "pending_payment" },
									{ text: Strings.orders.paymentStatuses.failed_payment, value: "failed_payment" },
									{ text: Strings.orders.paymentStatuses.cancelled, value: "cancelled" },
									{ text: Strings.orders.paymentStatuses.partially_refunded, value: "partially_refunded" },
									{ text: Strings.orders.paymentStatuses.refunded, value: "refunded" }
								],
								onFilter: (value: string | number | boolean, record: any) => {
									return record.paymentStatus === value;
								},
								width: 160
							},
							{
								title: Strings.orders.paymentDate,
								dataIndex: "payment",
								key: "paymentDate",
								render: (payment: any) => {
									if (payment?.paymentDate) {
										return DateTime.fromISO(payment.paymentDate).toFormat("dd/MM/yyyy");
									}
									return "-";
								},
								sorter: (a: any, b: any) => {
									return (
										(DateTime.fromISO(a.payment?.paymentDate).toMillis() || 0) -
										(DateTime.fromISO(b.payment?.paymentDate).toMillis() || 0)
									);
								},
								width: 140
							},
							{
								title: Strings.orders.paymentType,
								dataIndex: "payment",
								key: "paymentType",
								render: (status: any) => this.getPaymentType(status.paymentType),
								filters: [
									{ text: Strings.orders.cash, value: "cash" },
									{ text: Strings.orders.creditCard, value: "cc" },
									{ text: "MB Way", value: "mbw" },
									{ text: Strings.orders.bankTransfer, value: "bank_transfer" },
									{ text: Strings.orders.cashOnDelivery, value: "cash_on_delivery" }
								],
								onFilter: (value: string | number | boolean, record: any) => {
									return record.payment?.paymentType === value;
								},
								width: 160
							},
							{
								title: Strings.orders.shippingStatus,
								dataIndex: "shippingStatus",
								key: "shippingStatus",
								render: (status: string) => this.shippingStatusRender(status),
								filters: [
									{ text: Strings.orders.shippingStatuses.pending_processing, value: "pending_processing" },
									{ text: Strings.orders.shippingStatuses.shipped, value: "shipped" },
									{ text: Strings.orders.shippingStatuses.partially_shipped, value: "partially_shipped" },
									{ text: Strings.orders.shippingStatuses.delivered, value: "delivered" },
									{ text: Strings.orders.shippingStatuses.returned, value: "returned" },
									{ text: Strings.orders.shippingStatuses.partially_returned, value: "partially_returned" },
									{ text: Strings.orders.shippingStatuses.awaiting_pickup, value: "awaiting_pickup" },
									{ text: Strings.orders.shippingStatuses.cancelled, value: "cancelled" },
									{ text: Strings.orders.shippingStatuses.closed, value: "closed" }
								],
								onFilter: (value: string | number | boolean, record: any) => {
									return record.shippingStatus === value;
								},
								width: 160
							},
							{
								title: Strings.orders.status,
								dataIndex: "isClosed",
								key: "isClosed",
								render: (value: boolean) => this.getOrderStatus(value),
								sorter: (a: any, b: any) => Number(a.isClosed) - Number(b.isClosed),
								filters: [
									{ text: Strings.orders.closed, value: true },
									{ text: Strings.orders.pending, value: false }
								],
								onFilter: (value: string | number | boolean, record: any) => {
									return record.isClosed === value;
								},
								width: 140
							},
							{
								title: Strings.fields.total,
								dataIndex: "total",
								key: "total",
								render: (value: number) => (value != null ? formatPrice(value) : "-"),
								sorter: (a: any, b: any) => (a.total || 0) - (b.total || 0),
								align: "right",
								width: 120
							},
							{
								title: "",
								key: "view",
								align: "center",
								width: 60,
								render: (_: any, record: any) => (
									<Icon
										name="eye"
										style={{ cursor: "pointer" }}
										onClick={() => {
											dispatch(push(`/orders/${record._id}`));
										}}
									/>
								)
							}
						]}
						dataSource={orders}
						rowKey={(record) => record._id}
					/>
				</ContentWrapper>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
	countries: state.countries
});

export default connect(mapStateToProps)(Orders);
